import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../styles/Catering.css";
import BookingForm from "../components/BookingForm";

/* ======================================================
   REAL TIME CATERING MENUS
====================================================== */

const cateringMenus = [
  // ======================================================
  // TIFFEN MENUS
  // ======================================================

  {
    id: "TIFFEN-1",
    category: "Tiffen Menu",
    title: "Traditional Tiffen Menu",
    items: [
      "Kesari",
      "Idly (3 pcs)",
      "Sambaar",
      "Chutney",
      "Vadai (1 pc)",
    ],
    price: 99,
  },

  {
    id: "TIFFEN-2",
    category: "Tiffen Menu",
    title: "Premium Tiffen Menu",
    items: [
      "Kesari / Ashoka / Kasi Halwa",
      "Idly (2 pcs)",
      "Pongal",
      "Sambaar",
      "Chutney",
      "Tomato Chutney",
      "Vadai (1 pc)",
      "Mini Coffee",
    ],
    price: 199,
  },

  // ======================================================
  // LUNCH MENUS
  // ======================================================

  {
    id: "LUNCH-1",
    category: "Banana Leaf Lunch",
    title: "Traditional South Indian Lunch",
    items: [
      "Kadala Paruppu Payasam",
      "Curd Pachidi",
      "Potato Curry",
      "Koottu",
      "Kadamba Sambaar",
      "Rasam",
      "Pickle",
      "Vadai",
      "Appalam",
      "Sweet",
      "Daal",
      "Rice",
      "Ghee",
      "Thick Butter Milk",
      "Water Bottle",
      "Served on Banana Leaf",
    ],
    price: 350,
  },

  {
    id: "LUNCH-2",
    category: "Banana Leaf Lunch",
    title: "Premium Virundhu Feast",
    items: [
      "Milk Payasam",
      "Curd Pachidi",
      "Sweet Pachidi",
      "Kaara Curry",
      "Coconut Curry",
      "Aviyal",
      "Pickle",
      "Appalam",
      "Sweet",
      "Vadai",
      "Sambaar",
      "Rasam",
      "Veththa Kozhambu",
      "Daal",
      "Ghee",
      "Rice",
      "Variety Rice",
      "Thick Butter Milk",
      "Water Bottle",
      "Served on Banana Leaf",
    ],
    price: 450,
  },
];

/* ======================================================
   COMPONENT
====================================================== */

const Catering = () => {
  const location = useLocation();

  const [selectedMenu, setSelectedMenu] = useState(null);

  /* ======================================================
     AUTO MENU SELECTION
  ====================================================== */

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const type = params.get("type");

    if (type !== "catering") return;

    const defaultMenu = cateringMenus[0];

    setSelectedMenu(defaultMenu);

    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 300);
  }, [location.search]);

  /* ======================================================
     HANDLE BOOKING
  ====================================================== */

  const handleBooking = (menu) => {
    setSelectedMenu(menu);

    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  /* ======================================================
     RENDER
  ====================================================== */

  return (
    <div className="catering-page">
      {/* ======================================================
          HEADER
      ====================================================== */}

      <header className="catering-header">
        <h2>🍛 Traditional South Indian Catering Services</h2>

        <p className="intro">
          Authentic vegetarian catering services prepared with traditional
          South Indian taste for weddings, seemantham, upanayanam,
          house warming, family functions and all special occasions.
        </p>
      </header>

      {/* ======================================================
          TIFFEN MENUS
      ====================================================== */}

      <section className="menu-section">
        <div className="section-heading">
          <h3>☀️ Tiffen Menus</h3>

          <p>
            Freshly prepared traditional South Indian breakfast catering.
          </p>
        </div>

        <div className="menu-grid">
          {cateringMenus
            .filter((menu) => menu.category === "Tiffen Menu")
            .map((menu) => (
              <div className="menu-card" key={menu.id}>
                <div className="menu-top">
                  <span className="menu-category">
                    {menu.category}
                  </span>

                  <h3>{menu.title}</h3>
                </div>

                <ul>
                  {menu.items.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>

                <div className="menu-footer">
                  <p className="price">
                    ₹{menu.price} per person
                  </p>

                  <button
                    className="book-btn"
                    onClick={() => handleBooking(menu)}
                    aria-label={`Book ${menu.title}`}
                  >
                    Book This Menu
                  </button>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* ======================================================
          LUNCH MENUS
      ====================================================== */}

      <section className="menu-section">
        <div className="section-heading">
          <h3>🍃 Banana Leaf Lunch Menus</h3>

          <p>
            Traditional Tamil Virundhu style vegetarian feast packages.
          </p>
        </div>

        <div className="menu-grid">
          {cateringMenus
            .filter(
              (menu) => menu.category === "Banana Leaf Lunch"
            )
            .map((menu) => (
              <div className="menu-card premium" key={menu.id}>
                <div className="menu-top">
                  <span className="menu-category premium">
                    {menu.category}
                  </span>

                  <h3>{menu.title}</h3>
                </div>

                <ul>
                  {menu.items.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>

                <div className="menu-footer">
                  <p className="price">
                    ₹{menu.price} per person
                  </p>

                  <button
                    className="book-btn"
                    onClick={() => handleBooking(menu)}
                    aria-label={`Book ${menu.title}`}
                  >
                    Book This Menu
                  </button>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* ======================================================
          BOOKING FORM
      ====================================================== */}

      {selectedMenu && (
        <section className="booking-form-wrapper">
          <h3>📋 Book: {selectedMenu.title}</h3>

          <BookingForm
            type="Catering"
            menuName={selectedMenu.title}
            price={selectedMenu.price}
          />
        </section>
      )}
    </div>
  );
};

export default Catering;